module.exports = __webpack_public_path__ + "static/media/FTM-logo.60cf5ef1.png";